// removed by extract-text-webpack-plugin
module.exports = {"text800":"SJgpLfbBcHmte6F4Oy7PQ","text700":"_3shuBYmq-8nJbYeHOW2Aoc","text600":"buuNr0dtQaVOa5Kw5yoYZ","text500":"_2dyhsf5ZkZCkGGIYtmMMij","text400":"_1sfaNFk9nJRHAkJorVGNkJ","text300":"_3KpbIQRlTepTVMNY6hdIZ0","text200":"ZKZpAsZgkp5Uoqa1uWux","textParagraph":"_2v_ubLFy045TMJ2phP7P7A","crimp":"VGfy_R09bTSNTCGTmC-Je","brandName":"_1etKv515t7Ges3ivi0JsRB","trim":"QiY-FngcsfJW6jh8HzE3j","brand":"_1g-J43k6M3ZZVvb4WkaOJr","flexCenter":"ijsi91LQDgic4jIyVuNXu","hideTextOverflow":"_1ZA8lihjMVOI4ntpsyNJ3w","marginPageMainContent":"_37qDPJrXKj9yxzs5TcpyZf","brandLogo":"_3hnRwUE9t41uq7Yy6ByrM2"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/templates/components/PageHeader/HeaderItemBrand.scss
// module id = 633
// module chunks = 0